import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { PlusOutlined } from '@ant-design/icons'
import { Tabs, Form, Row, Col, Select, Modal } from 'antd';
import Input from '../../../../../ui/Input';
import PageContainer from "../../../../../CSIComponents/PageContainer";
import { getOTACodes } from "../../../../../../services/common";
import {statesList} from '../constants/statesList'
const { TabPane } = Tabs;
const { Option } = Select;
let errHandle = false;
let newTabIndex = 0;
const PaymentAddressAdd = forwardRef((props: any, paymentAddressAddRef: any) => {
  const [form]: any = Form.useForm()
  useImperativeHandle(paymentAddressAddRef, () => ({ paymentAddressForm: form, restoreErr: () => { errHandle = false } }))
  let initialPanes = [{ id: '1', name: 'Payment Address 1', content: 'Content of new Tab', addressline: [{ text: '' }], closable: true }]
  const [activeKey, setActiveKey] = useState(initialPanes[0].id)
  const [panes, setPanels] = useState(initialPanes)
  const [isRequired, setIsRequired] = useState(true)
  const [states] = useState<string[]>(statesList)

  const ModalHead = () => {
    return (
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '50px',
        lineHeight: '50px',
        textIndent: '10px',
        borderBottom: '1px solid #ccc',
        color: '#fff',
        background: '#06789D',
        fontSize: 18,
        width: '100%'
      }}>Confirm</div>
    )
  }
  const onChange = (activeKey: any) => {
    setActiveKey(activeKey)
  };
  const onEdit = (targetKey: any, action: any) => {
    if (action == 'add') {
      add()
    } else if (action == 'remove') {
      remove(targetKey)
    }
  };

  const add = () => {
    setIsRequired(true);
    const newKey = ++newTabIndex;
    const newPanes = [...panes];
    newPanes.push(
      {
        name: 'Payment Address ' + newKey,
        content: 'Content of new Tab',
        id: newKey + '',
        addressline: [{ text: '' }],
        closable: true
      }
    );
    newPanes[0].closable = true;
    setPanels(newPanes)
    setActiveKey(JSON.stringify(newKey))
  };

  const remove = (targetKey: any) => {
    let deleteTabName = panes.filter((item: any) => targetKey == item.id)
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ${deleteTabName[0].name} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      transitionName: '',
      maskTransitionName: '',
      onOk() {
        if (panes.length === 1) {
          form.resetFields()
          setIsRequired(false)
          props.validateFieldsError();
        } else {
          let newActiveKey = activeKey;
          let lastIndex: any;
          panes.forEach((pane: any, i: any) => {
            if (pane.id == targetKey) {
              lastIndex = i - 1;
            }
          });
          const newPanes = panes.filter((pane: any) => pane.id !== targetKey);
          if (newPanes.length && newActiveKey === targetKey) {
            if (lastIndex >= 0) {
              newActiveKey = newPanes[lastIndex].id;
            } else {
              newActiveKey = newPanes[0].id;
            }
          }
          if (newPanes.length === 1) {
            newPanes[0].closable = true;
          }
          setPanels(newPanes)
          setActiveKey(newActiveKey)
        }
      },
      onCancel() {

      },
    });
  };
  useEffect(() => {
    newTabIndex = panes.length > 0 ? panes.length : 1;
    panes.forEach((item: any, index: any) => {
      form.setFieldsValue({
        [`name-${item.id}`]: item.name,
        [`type-${item.id}`]: item.type,
        [`pobox-${item.id}`]: item.pobox,

        [`city-${item.id}`]: item.city,
        [`state-${item.id}`]: item.state,
        [`country-${item.id}`]: item.country,
        [`postalcode-${item.id}`]: item.postalcode,
      })
      item.addressline.forEach((address: any, i: number) => {
        form.setFieldsValue({
          [`address-${item.id}**${i}`]: address.text,
        })
      })
    })
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])
  const addAddress = (index: number) => {
    panes[index].addressline.push({ text: '' })
    setPanels([...panes])
  }
  const deleteAddress = (index: number, id: string) => {
    const addressLastName = "address-" + id + '**' + panes[index].addressline.length
    panes[index].addressline.pop()
    form.setFieldsValue({ [addressLastName]: '' })
    setPanels([...panes])
  }
  const [couData, setCouData] = useState([])
  const getCouData = async () => {
    let res = await getOTACodes('COU', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      setCouData(res.otacodes)
    } else {
      setCouData([])
    }
  };
  const [autData, setAutData] = useState([])
  const getAutData = async () => {
    let res = await getOTACodes('AUT', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      setAutData(res.otacodes)
    } else {
      setAutData([])
    }
  };
  useEffect(() => {
    getCouData();
    getAutData();
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])
  useEffect(() => {
    if (errHandle) {
      setIsRequired(true);
      props.validateFieldsError();
    } else {
      errHandle = true;
    }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [panes])

  return (
    <>
      <PageContainer style={{ marginBottom: '90px' }}>
        <div style={{ background: '#fff', padding: '20px 10px 20px 0' }}>
          <Form
            layout="vertical"
            form={form}
            name="basic"
            onValuesChange={(changedFields, allFields) => {
              setIsRequired(true);
              props.validateFieldsError();
            }}
          >
            <Tabs
              type="editable-card"
              onChange={onChange}
              activeKey={activeKey}
              onEdit={onEdit}
            >
              {panes.map((pane: any, i: number) => (
                <TabPane tab={'Payment Address ' + pane.id} closable={pane.closable} key={pane.id} forceRender={true}>
                  <PageContainer>
                    <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item
                          label="Address Name"
                          name={`addname-${pane.id}`}
                          rules={[{ max: 64, message: 'You have reached the max character length of 64' }]}
                        >
                          <Input maxLength={64} />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          label="Address Type"
                          name={`type-${pane.id}`}
                          rules={[{ required:  false, message: 'This field is required' }]}
                        >
                          <Select allowClear showSearch
                            optionFilterProp="children"
                            // @ts-expect-error 
                            filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {autData.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}></Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={6}>
                        <Form.Item
                          label="PO Box"
                          name={`pobox-${pane.id}`}
                          rules={[{ max: 32, message: 'You have reached the max character length of 32' }]}
                        >
                          <Input maxLength={32} />
                        </Form.Item>
                      </Col>
                    </Row>
                    {pane.addressline.map((address: any, index: number) => {
                      return <Row gutter={24} key={index}>
                        <Col span={18}>
                          <Form.Item
                            label={"Address" + (index + 1)}
                            name={`address-${pane.id}**${index + 1}`}
                            rules={[{ required: false, message: 'This field is required' },
                            { max: 64, message: 'You have reached the max character length of 64' }]}
                          >
                            <Input maxLength={64} />
                          </Form.Item>
                        </Col>
                        <Col span={6}></Col>
                      </Row>
                    })}
                    <Row gutter={24} >
                      <Col span={18} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        {pane?.addressline?.length < 4 && <div style={{ color: '#004771', display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => addAddress(i)}><PlusOutlined style={{ marginRight: 4 }} />Add Address {pane.addressline.length + 1}</div>}
                        {pane.addressline.length > 1 && <div style={{ color: '#f07171', marginLeft: 20, cursor: 'pointer' }} onClick={() => { deleteAddress(i, pane.id) }}>Delete</div>}
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={6}>
                        <Form.Item
                          label="City"
                          name={`city-${pane.id}`}
                          rules={[{ max: 64, message: 'You have reached the max character length of 64' }]}
                        >
                          <Input maxLength={64} />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                          <Form.Item
                                label="State"
                                name={`state-${pane.id}`}
                          >
                            <Select allowClear showSearch
                                defaultValue={pane.state}>
                                {
                                    states.map((state: string, index: number) => (
                                    <Option value={state} key={index}>{state}</Option>
                                    ))
                                }
                            </Select>
                          </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          label="Country"
                          name={`country-${pane.id}`}
                        >
                          <Select allowClear showSearch
                            optionFilterProp="children"
                            // @ts-expect-error 
                            filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {couData.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}></Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={6}>
                        <Form.Item
                          label="Postal Code"
                          name={`postalcode-${pane.id}`}
                          rules={[{max: 10, message: 'You have reached the max character length of 10' }]}
                        >
                          <Input maxLength={10} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </PageContainer>
                </TabPane>
              ))}
            </Tabs>
          </Form>
        </div>
      </PageContainer>
    </>
  )
})

export default PaymentAddressAdd
